// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { IconAddCircleOutline } from 'components/atoms/icons/IconAddCircleOutline';
import styles from './index.module.scss';
import { EmissionSite } from 'types/routeManagementTypes';
import Popover from 'components/atoms/Popover';

interface SearchSiteItemProps {
  site: EmissionSite;
  onAddSite: () => void;
}

const SearchSiteItem = ({ site, onAddSite }: SearchSiteItemProps) => {
  return (
    <div className={`${styles.placeItem} ${styles.block}`}>
      <div className={styles.info}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Popover
            content={site.name}
            autoGen={{
              lines: 1,
              odd: 4,
            }}
            positions={['top']}
            containerStyle={{
              maxWidth: '600px',
              wordBreak: 'break-all',
            }}
          >
            <p className={styles.siteName}>{site.name}</p>
          </Popover>
        </div>
        <div className={styles.address}>{site.address}</div>
      </div>
      <span className="pointer">
        <IconAddCircleOutline stroke="#e7e7e7" size={30} onClick={onAddSite} />
      </span>
    </div>
  );
};
export default SearchSiteItem;
